import MovieFooter from './movie-footer';

export default MovieFooter;
